import React from 'react';
import { SkeletonLine } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from './Skeleton.st.css';
import { DataHooks } from './DataHooks';

export const Skeleton = ({
  isLine = false,
  className,
  dataHook = DataHooks.Root,
}: {
  isLine?: boolean;
  className?: string;
  dataHook?: string;
}) => (
  <SkeletonLine
    data-hook={dataHook}
    className={st(classes.root, { isLine }, className)}
  />
);
